module.exports = __webpack_public_path__ + "static/media/applications-programming-svgrepo-com.0b5ef06c.svg";